import DriverCandidatureActiveRequest from "../../../../api/raily/driver/candidature/active/driver-candidature-active.request";
import DriverCandidatureActiveParams from "./driver-candidature-active-params";

const create = (
  params: DriverCandidatureActiveParams,
): DriverCandidatureActiveRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverCandidatureActiveParamsFactory = {
  create,
};

export default driverCandidatureActiveParamsFactory;
